import React from 'react';
import fire from '../../../auth/firebase';
import '../../styles/styles.css';


export class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alertShow: false,
            setShow: '',
            message: '',
            isFailure: false,
            email: '',
            password: '',
            confirmPassword: '',
            emailError: '',
            passwordError: '',
            confirmPasswordError: '',
            successMessage: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.clearInputs = this.clearInputs.bind(this);
        this.clearErrors = this.clearErrors.bind(this);
        this.send_verification = this.send_verification.bind(this);
    }

    onChange(e) {
        this.clearErrors();
        this.setState({ [e.target.name]: e.target.value });
    }

    clearInputs() {
        this.setState({email: '', password: '', confirmPassword: ''})
    }

    clearErrors() {
        this.setState({emailError: '', passwordError: '', confirmPasswordError: '', successMessage: ''})
    }

    send_verification() {
        var user = fire.auth().currentUser;

        user.sendEmailVerification().then((res) => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        })
    }

    onSubmit(e) {
        this.clearErrors();
        e.preventDefault();

        const user = {
            email: this.state.email,
            password: this.state.password,
            confirmPassword: this.state.confirmPassword
        };

        if (user.password !== user.confirmPassword) {
            this.setState({ confirmPasswordError: 'The password isn`t matching', isFailure: true, alertShow: true });
        }

        else {

            fire.auth().createUserWithEmailAndPassword(user.email, user.password)
                .then(result => {
                    console.log(result);
                    this.setState({successMessage: 'User registered successfully! Email was sen`t for verification', isFailure: false, alertShow: true});
                    this.send_verification();
                }).catch(error => {
                    // eslint-disable-next-line default-case
                    switch (error.code) {
                        case "auth/email-already-in-use":
                        case "auth/invalid-email":
                        case "auth/operation-not-allowed":
                            this.setState({ emailError: error.message, isFailure: true, alertShow: true });
                            break;
                        case "auth/weak-password":
                            this.setState({ passwordError: error.message, isFailure: true, alertShow: true });
                            break;
                    }
                });
        }
    }


    render() {

        return (
            <>
                <section className="login">
                    <div className="loginContainer">
                        <label>Email</label>
                        <input
                            type="text"
                            name="email"
                            autoFocus
                            required
                            value={this.email}
                            onChange={e => this.onChange(e)}
                        />
                        <p className="errorMsg">{this.state.emailError}</p>
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            required
                            value={this.password}
                            onChange={e => this.onChange(e)}
                        />
                        <p className="errorMsg">{this.state.passwordError}</p>
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            required
                            value={this.confirmPassword}
                            onChange={e => this.onChange(e)}
                        />
                        <p className="errorMsg">{this.state.confirmPasswordError}</p>
                        <p className="successMsg">{this.state.successMessage}</p>
                        <div className="btnContainer">
                            <>
                                <button onClick={this.onSubmit}>Sign up</button>
                                <p>
                                    Have an account?
                            <span onClick={() => window.location.href = '/'}>Sign in</span>
                                </p>
                            </>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}